<div fxLayout="column" class="dialog-content-wrapper">
  <app-button-close-modal
    (close)="closeModal()"
    fxLayoutAlign="flex-end none"
    class="button"></app-button-close-modal>
  <app-infor-panel [stageId]="data.stage" class="panel"></app-infor-panel>
</div>
